module.exports = __webpack_public_path__ + "static/media/GD.5d4e0267.jpg";